import BaseController       from "controllers/backend/base"
import { withGooglePlaces } from "servos/googlePlaces"

class Controller extends BaseController {
  call() {
    super.call();
    bindLocationAutocomplete.call(this)
  }
};

const bindLocationAutocomplete = function() {
  const input = this.root.find('.location')
  if (input.length === 0) return

  withGooglePlaces(() => {
    input.geocomplete()
  })
};

export default Controller;
